import React from 'react';
import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';
import './MegaMenu.css';

interface MegaMenuProps {
    category: string;
    items: { label: string; link: string }[];
    images?: { url: string, link: string }[];
    onClose: () => void;
}

// Split items into columns of max `size` items each
function chunkArray<T>(arr: T[], size: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
    }
    return chunks;
}

const MegaMenu: React.FC<MegaMenuProps> = ({ category, items, images, onClose }) => {
    const columns = chunkArray(items, 8);

    return (
        <motion.div
            className="mega-menu"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
            onMouseLeave={onClose}
        >
            <div className="container mega-menu-container">
                <div className="mega-menu-content">
                    {/* Subcategory Columns */}
                    <div className="mega-menu-columns">
                        <h4 className="mega-menu-title">{category}</h4>
                        <div className="mega-menu-columns-grid">
                            {columns.map((col, colIdx) => (
                                <div className="mega-menu-column" key={colIdx}>
                                    <ul className="mega-menu-links">
                                        {col.map((item, index) => (
                                            <li key={index}>
                                                <NavLink to={item.link} onClick={onClose} className="mega-link">
                                                    {item.label}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Featured Images (if any) */}
                    {images && images.length > 0 && (
                        <div className="mega-menu-featured">
                            {images.map((img, index) => (
                                <NavLink key={index} to={img.link} onClick={onClose} className="mega-featured-item no-underline">
                                    <div className="mega-featured-image-wrapper">
                                        <img src={img.url} alt={`Featured ${category}`} className="mega-featured-image" />
                                        <div className="mega-featured-overlay">
                                            <span className="mega-featured-label">Shop Now</span>
                                        </div>
                                    </div>
                                    <p className="mega-featured-caption">Collection {index + 1}</p>
                                </NavLink>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </motion.div>
    );
};

export default MegaMenu;
